<template>
  <div class="leo2-home" v-if="$mode == 1">
    <div class="ok-home">
      <a class="link-down" href="javascript:;" @click="loadInstall()"
        >安卓用户可下载到电脑</a
      >
    </div>
    <div class="okzhuan-title">
      <span>指尖一动，试玩即燃</span>
      <p>在试玩中遇见惊喜，让快乐不期而至</p>
    </div>
    <div class="okzhuan-con">
      <div class="child">
        <img src="../assets/images/pic_7.png?v=1" />
        <div class="top">海量试玩，收益不停</div>
        <div class="top2">每日上新，指尖即赚</div>
        <div class="top3">碎片时间，轻松变现</div>
      </div>
      <div class="child">
        <img src="../assets/images/pic_8.png?v=1" />
        <div class="top">好友同行，福利加倍</div>
        <div class="top2">邀请好友，共享奖励</div>
        <div class="top3">组队试玩，快乐翻倍</div>
      </div>
      <div class="child">
        <img src="../assets/images/pic_9.png?v=1" />
        <div class="top">活动不断，惊喜连连</div>
        <div class="top2">精选福利，天天有料</div>
        <div class="top3">玩得尽兴，收获满满</div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="ok-bg"></div>
    <div class="leo2-home">
      <div class="okzhuan-title">
        <span>动动手指，轻松体验</span>
        <p>一起探寻更多欢乐</p>
      </div>
      <div class="okzhuan-con">
        <div class="child1">
          <img src="../assets/images/pic_4.png?v=1" />
          <div class="desc">
            <div class="top">应用多 · 福利好</div>
            <div class="top2">每日大量上新</div>
            <div class="top3">随时随地轻松玩</div>
          </div>
        </div>
        <div class="child1">
          <img src="../assets/images/pic_6.png?v=1" />
          <div class="desc">
            <div class="top">活动全 · 乐趣多</div>
            <div class="top2">超多精选福利活动</div>
            <div class="top3">开心快乐每一天</div>
          </div>
        </div>
      </div>
      <div class="copyright">
        © 2024 珠海XX网络科技有限公司&nbsp;&nbsp;版权所有&nbsp;&nbsp;<span
          @click="icp(1)"
          >增值电信业务经营许可证：粤XXXXXXXXXX</span
        >&nbsp;&nbsp;<span @click="icp(2)">粤ICP备XXXXXXXXX</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downloadUrl: {},
      isDisabled: false,
    };
  },
  mounted() {
    if (this.$mode == 1) {
      document.title = "玩得赚 - 一个创造价值的试玩APP";
    } else {
      document.title = "玩得赚 - 一个创造价值的APP";
    }
  },
  methods: {
    loadInstall() {
      // 不要重复点击
      if (this.isDisabled) {
        return false;
      }

      this.isDisabled = true;
      this.axios.install().then((res) => {
        this.downloadUrl = res.data.data.DownloadUrl;
        this.isDisabled = false;
        window.location.href = this.downloadUrl;
      });
    },
    icp(type) {
      if (type == 1) {
        window.open(
          "https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=XXXXXXXXX&type=xuke",
        );
      } else {
        window.open("https://beian.miit.gov.cn/#/Integrated/index");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ok-bg {
  height: 1211px;
  width: 100%;
  background: url(../assets/images/banner2.png?v=2) no-repeat center top;
  /* background-size: 100% auto; */
  position: relative;
}
.leo2-home {
  overflow: hidden;
  /*margin-top: 80px;*/
  background-color: #fff6ee;
  .ok-home {
    height: 931px;
    width: 100%;
    background: url("../assets/images/banner.png?v=5") no-repeat center bottom;
    /*background-size: 100% auto;*/
    position: relative;

    .cl-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 200px;
      background-color: #f44534;
      z-index: -1;
    }

    .link-down {
      position: absolute;
      z-index: 9999;
      bottom: 34%;
      font-size: 24px;
      left: 49.4%;
      top: calc(80%);
      /*top: 70%;*/
      text-align: center;
      margin-left: -142px;
      color: #fff;
      transform: rotate(14.5deg);
    }
  }

  .okzhuan-title {
    text-align: center;
    overflow: hidden;
    color: #000;
    padding-top: 100px;

    span {
      font-size: 48px;
      font-weight: bold;
      line-height: 67px;
      display: block;
      padding-bottom: 16px;
    }

    p {
      padding: 0;
      margin-top: 10px;
      line-height: 32px;
      font-size: 34px;
    }
  }

  .okzhuan-con {
    display: flex;
    padding-top: 80px;
    padding-bottom: 120px;
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    justify-content: space-between;
    .child {
      text-align: center;
      color: #000;
      // &:nth-child(1) {
      //   margin-left: 30px;
      // }
      // &:nth-child(3) {
      //    margin-right: 30px;
      // }
      span {
        color: #f44534;
      }

      img {
        display: block;
        width: 250px;
        height: 250px;
        vertical-align: middle;
        margin: 0 auto;
      }

      .top {
        font-size: 32px;
        font-weight: bold;
        line-height: 32px;
        margin-top: 16px;
      }

      .top2 {
        font-size: 24px;
        line-height: 24px;
        margin-top: 32px;
      }

      .top3 {
        font-size: 24px;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    .child1 {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 30px;
        .top {
          font-size: 24px;
          font-weight: bold;
          line-height: 24px;
          margin-top: 16px;
        }

        .top2 {
          font-size: 16px;
          line-height: 16px;
          margin-top: 32px;
        }

        .top3 {
          font-size: 16px;
          line-height: 16px;
          margin-top: 10px;
        }
      }
    }
  }

  .copyright {
    height: 114px;
    background: #f5f5f5;
    text-align: center;
    font-size: 16px;
    line-height: 72px;
    color: #333333;
    span {
      cursor: pointer;
    }
  }

  @media (max-width: 1900px) {
    .link-down {
      top: 70%;
    }
  }
}
@media (min-width: 1920px) {
  .leo2-home {
    .ok-home {
      background-size: 100%;
    }
  }
}
</style>
